import Page from './Page.styles';

export default Page;
